import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedPassword = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 49,
	viewBox: "0 0 48 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.1035 30.4375C15.7528 30.4375 17.1547 29.8602 18.3092 28.7057C19.4638 27.5512 20.041 26.1493 20.041 24.5C20.041 22.8507 19.4638 21.4488 18.3092 20.2943C17.1547 19.1398 15.7528 18.5625 14.1035 18.5625C12.4542 18.5625 11.0523 19.1398 9.89779 20.2943C8.74327 21.4488 8.16602 22.8507 8.16602 24.5C8.16602 26.1493 8.74327 27.5512 9.89779 28.7057C11.0523 29.8602 12.4542 30.4375 14.1035 30.4375ZM14.1035 36.375C10.8049 36.375 8.00108 35.2205 5.69206 32.9115C3.38303 30.6024 2.22852 27.7986 2.22852 24.5C2.22852 21.2014 3.38303 18.3976 5.69206 16.0885C8.00108 13.7795 10.8049 12.625 14.1035 12.625C16.7754 12.625 19.1092 13.3837 21.1048 14.901C23.1005 16.4184 24.4941 18.2986 25.2858 20.5417H41.8613L45.7702 24.4505L38.8431 32.3672L33.8952 28.4583L29.9368 32.4167L25.9785 28.4583H25.2858C24.4612 30.8333 23.0263 32.7465 20.9811 34.1979C18.936 35.6493 16.6434 36.375 14.1035 36.375Z",
		fill: "url(#paint0_linear_2005_4064)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_2005_4064",
		x1: 1.99941,
		y1: 36.6875,
		x2: 32.1832,
		y2: .718501,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedPassword;
